import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Input, Upload, notification } from "antd";

import CustomButton from "../../../../../../components/Button/Button";

const MAX_LENGTH = 5000000; // 5Mbs;

const UploadDocument = ({ defaultFilename, onChange }) => {
  const { t } = useTranslation(["opportunity"]);
  const [filename, setFilename] = useState(defaultFilename);

  const beforeUpload = file => {
    if (file.size > MAX_LENGTH) {
      setFilename(undefined);
      notification.error({
        message: "Error",
        description: t(
          "opportunity:process.stepTypes.chatbot.tree.documentLimit",
          { size: MAX_LENGTH / 1000000 }
        )
      });
    } else {
      setFilename(file.name);
    }
    return false;
  };

  const handleChange = ({ file }) => onChange(file);

  return (
    <div style={{ display: "flex" }}>
      <div style={{ width: "100%" }}>
        <Input
          disabled
          value={filename}
          placeholder={t(
            "opportunity:process.stepTypes.chatbot.tree.emptyDocument"
          )}
        />
      </div>
      <Upload
        showUploadList={false}
        multiple={false}
        beforeUpload={beforeUpload}
        onChange={handleChange}
      >
        <CustomButton
          icon="upload"
          style={{ marginLeft: 15, minWidth: "auto" }}
        >
          {t("opportunity:process.stepTypes.chatbot.tree.uploadDocument")}
        </CustomButton>
      </Upload>
    </div>
  );
};

export default UploadDocument;
